import { useState } from 'react';
import { useStudioPanorama } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
export const useInitSuccess = () => {
  const module = useCurrentModule();
  const [didInitSuccess, setDidInitSuccess] = useState(false);
  const [eventAggregator, setEventAggregator] = useState(undefined);
  const panorama = useStudioPanorama();
  const handleInitSuccess = orderPageEventAggregator => {
    if (!didInitSuccess) {
      module.internals.bi.onCheckoutPageLoad == null || module.internals.bi.onCheckoutPageLoad({});
      panorama.finishTransaction('checkout-page-load', {
        eventAggregator: orderPageEventAggregator
      });
    }
    setEventAggregator(orderPageEventAggregator);
    setDidInitSuccess(true);
  };
  return {
    eventAggregator,
    handleInitSuccess,
    didInitSuccess
  };
};
//# sourceMappingURL=useInitSuccess.js.map